import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PromotionsService } from 'src/app/api/promotions.service';
import { InviteAndEarnPromotion, VerifyAndEarnPromotion } from 'src/app/models/promotions';
import { CacheDuration, StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
  readonly REFERRAL_ID_KEY = 'referralId';

  loading = false;
  error: string = null;

  referralId: string
  verifyAndEarnPromotion: VerifyAndEarnPromotion;
  inviteAndEarnPromotion: InviteAndEarnPromotion;

  constructor(
    private route: ActivatedRoute,
    private promotionsService: PromotionsService,
    private storageService: StorageService
  ) { }

  ngOnInit() {
    this.getReferralId();
    this.getPromotions();
  }

  getPromotions() {
    this.loading = true;
    
    this.promotionsService.getAllPromotions({
      inviteAndEarn: {
        referralId: this.referralId
      }
    }).subscribe(response => {
      this.loading = false;
      this.verifyAndEarnPromotion = response?.verifyAndEarn;
      this.inviteAndEarnPromotion = response?.inviteAndEarn;
    }, err => {
      this.loading = false;
      this.error = err?.errors?.[0]?.message;
    });
  }

  getReferralId() {
    const referralId = this.route.snapshot.queryParamMap.get('referralId');

    if (referralId) {
      this.storageService.set(this.REFERRAL_ID_KEY, referralId, CacheDuration.OneHour);
    }

    this.referralId = this.storageService.get(this.REFERRAL_ID_KEY);
  }
}
